import React from 'react';
import '../styles/ServicesSection.css';

const ServicesSection = () => {
  return (
    <section id="services" aria-labelledby="why-title-html">
      <h2 id="why-title-html">WHY CHOOSE INDUSTRY MAX</h2>
      <p className="subtitle">
        We provide innovative IT solutions and security systems that help organizations grow and perform efficiently,
        <span className="subtitle-line elementor-typo">thereby improving business stability and achieving more efficient operations.</span>
      </p>

      <div className="services">
        <div className="service-box">
          <div className="icon elementor-icon" aria-hidden="true">
            <i className="fas fa-laptop-code"></i>
          </div>
          <h3 className="elementor-icon-box-title">IT SOLUTIONS</h3>
          <ul>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Computer systems and software trading</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Communication equipment solutions</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Business process optimization</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Technology infrastructure planning</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Scalable and secure systems</li>
          </ul>
        </div>

        <div className="service-box">
          <div className="icon elementor-icon" aria-hidden="true">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h3 className="elementor-icon-box-title">SECURITY SYSTEMS</h3>
          <ul>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Electronic security alarm systems</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Burglar and fire alarm monitoring</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Remote monitoring services</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Professional installation</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Regular maintenance support</li>
          </ul>
        </div>

        <div className="service-box">
          <div className="icon elementor-icon" aria-hidden="true">
            <i className="fas fa-certificate"></i>
          </div>
          <h3 className="elementor-icon-box-title">LICENSED SERVICES</h3>
          <ul>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Meydan Free Zone Authority licensed</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Professional technical services</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Reliable and trusted solutions</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Comprehensive support</li>
            <li><i className="fas fa-check" style={{marginRight: '6px', color: '#1e3a8a'}}></i>Innovative technology focus</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
